import React from 'react';
import type { SearchRequest } from 'searchkit';

import { SearchkitWrapper } from '@uncinc/react-searchkit';

import { APP_OPTIONS, SEARCH_ALL_CONTENT_HITS_PER_PAGE, SEARCHKIT_HOST_URL } from '../../config/constants';
import { facetAttributes, resultAttributes, searchAttributes } from './config';

// Subcomponents.
import Facets from './Facets';
import Pagination from './Pagination';
import Results from './Results';
import SearchBar from './SearchBar';
import Stats from './Stats';

interface SearchAllContentSubComponents {
  Facets: typeof Facets;
  Pagination: typeof Pagination;
  Results: typeof Results;
  SearchBar: typeof SearchBar;
  Stats: typeof Stats;
}

export interface SearchAllContentProps {
  children: React.ReactNode;
}

// eslint-disable-next-line max-len
const SearchAllContent: React.FC<SearchAllContentProps> & SearchAllContentSubComponents = (props) => {
  const { children } = props;

  return (
    <SearchkitWrapper
      className="SearchAllContent"
      connection={{
        host: SEARCHKIT_HOST_URL,
      }}
      routing
      indexName={APP_OPTIONS.parameters.searchkitIndexAllContent}
      hitsPerPage={SEARCH_ALL_CONTENT_HITS_PER_PAGE}
      searchSettings={{
        search_attributes: searchAttributes,
        result_attributes: resultAttributes,
        facet_attributes: facetAttributes,
      }}
      requestOptions={{
        hooks: {
          beforeSearch: (requests: SearchRequest[]) => {
            requests.forEach((request) => {
              const existingQuery = request.body.query;

              request.body.query = {
                bool: {
                  must: existingQuery,
                  must_not: [
                    {
                      wildcard: {
                        url: '*/logos-weggooiwijzer',
                      },
                    },
                    {
                      wildcard: {
                        url: '*/logos-disposal-guide',
                      },
                    },
                  ],
                },
              };
            });

            return Promise.resolve(requests);
          },
        },
      }}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchAllContent.Facets = Facets;
SearchAllContent.Pagination = Pagination;
SearchAllContent.Results = Results;
SearchAllContent.SearchBar = SearchBar;
SearchAllContent.Stats = Stats;

export default SearchAllContent;
